export const tableColumns = [
    {
        name: 'Experience ID',
        selector: row => row.exp_id,
        sortable: true,
        center: true,
        minWidth: '9.375rem',
        cell: row => (
            <span style={{ 
                color: '#5C61F2', 
                fontWeight: 'bold'
            }}>
                {row.exp_id}
            </span>
        ),
    },
    {
        name: 'Experience Title',
        selector: row => row.experience_title,
        sortable: true,
        center: true,
        minWidth: '15rem',
       
    },
    {
        name: 'Author',
        selector: row => row.author,
        sortable: true,
        center: true,
        minWidth: '9.375rem',
    },
    {
        name: 'Submitted Date',
        selector: row => row.submittedDate,
        sortable: true,
        center: true,
        minWidth: '9.375rem',
    },
    {
        name: 'Updated by',
        selector: row => row.updatedBy,
        sortable: true,
        center: true,
        minWidth: '9.375rem',
    },
    {
        name: 'Updated On',
        selector: row => row.updatedOn,
        sortable: true,
        center: true,
        minWidth: '9.375rem',
    },
    {
        name: 'Status',
        selector: row => row.status,
        sortable: true,
        center: true,
        minWidth: '6.25rem',
    },
    {
        name: 'Action',
        selector: row => row.action,
        sortable: false,
        center: true,
        minWidth: '10rem',
    },
];